// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_he-6";
export var emphasizeQuantity = "_he-3";
export var flatBottomCorners = "_he-5";
export var productImage = "_he-0";
export var quantityContainer = "_he-2";
export var tooltip = "_he-1";
export var wrapAndEllipsesOverflow = "_he-4";